import { render } from "./CountryTownBuild.vue?vue&type=template&id=1a18538f&scoped=true"
import script from "./CountryTownBuild.vue?vue&type=script&lang=js"
export * from "./CountryTownBuild.vue?vue&type=script&lang=js"

import "./CountryTownBuild.vue?vue&type=style&index=0&id=1a18538f&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a18538f"]])

export default __exports__